import React from 'react';

const FabricAndCareIconJag = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.60352 3.9375V8.53752L5.64518 8.19165V4.97917H10.3632L10.7101 3.9375H4.60352ZM12.5594 3.9375L12.9063 4.97917H15.0202V14.3542H5.64518V10.6208L4.60352 10.275V15.3958H16.0618V3.9375H12.5594ZM11.6348 4.45833L11.179 5.82552L9.81185 6.28125L11.179 6.73698L11.6348 8.10417L12.0905 6.73698L13.4577 6.28125L12.0905 5.82552L11.6348 4.45833ZM7.11613 7.58333L6.6604 8.95052L5.29321 9.40625L6.6604 9.86198L7.11613 11.2292L7.57186 9.86198L8.93905 9.40625L7.57186 8.95052L7.11613 7.58333ZM12.1556 9.66667L11.6999 11.0339L10.3327 11.4896L11.6999 11.9453L12.1556 13.3125L12.6113 11.9453L13.9785 11.4896L12.6113 11.0339L12.1556 9.66667Z"
      fill="black"
    />
  </svg>
);

export default FabricAndCareIconJag;
